@if (formCategories) {
    <div class="form-status-overview">
        <div class="detail-page-action-bar">
            <input
                type="text"
                class="form-control form-control-sm"
                name="filterInput"
                [(ngModel)]="filter"
                (debounce-input-event)="filterTrigger()"
                placeholder="Search / filter invites"
                inputTooltip
            />
        </div>

        <div class="categories">
            @for (category of formCategories; track category) {
                @if (!category.hidden) {
                    <div class="category-overview">
                        <div class="category-title">
                            {{ category.category }}
                        </div>
                        @for (form of category.forms; track form; let i = $index) {
                            <div
                                class="status-overview"
                                [class.workflow-status-overview]="form.Workflow"
                            >
                                <div
                                    [hidden]="filter && form._genericConfig._visibleRowCount === 0"
                                >
                                    <div class="detail-page-card headers mb-0 row">
                                        <div
                                            class="detail-page-card-title col-{{
                                                form.CanInvite ? '12' : '6'
                                            }}"
                                        >
                                            <div
                                                class="open-color me-2"
                                                [style.background-color]="
                                                    form.IsOpenForEntries
                                                        ? form.FormOutOfDateRange
                                                            ? 'orange'
                                                            : 'green'
                                                        : 'red'
                                                "
                                                [matTooltip]="
                                                    form.IsOpenForEntries
                                                        ? form.FormOutOfDateRange
                                                            ? 'Form outside daterange'
                                                            : 'Form is open for entries.'
                                                        : 'Form is closed for entries.'
                                                "
                                            ></div>
                                            {{ form.Title }}
                                            @if (form.Workflow) {
                                                <i
                                                    class="fas fa-code-branch ms-2"
                                                    matTooltip="This is a worklfow form."
                                                ></i>
                                            }
                                            @if (form.EndDate) {
                                                <small class="text-muted ms-2"
                                                    >(End date:
                                                    {{ form.EndDate | dateFormat }})</small
                                                >
                                            }
                                        </div>
                                        <div
                                            class="detail-page-card-actions col-{{
                                                form.CanInvite ? '12' : '6'
                                            }}"
                                        >
                                            @if (form.CanInvite) {
                                                <div class="left-items">
                                                    <button
                                                        class="btn btn-raised green"
                                                        (click)="openRequiredInvite(form)"
                                                    >
                                                        <i class="far fa-envelope"></i>
                                                        <span>Invite users</span>
                                                    </button>
                                                    @if (form._hasOpenInvites) {
                                                        <button
                                                            class="btn btn-raised dark"
                                                            (click)="openRemindInvite(form)"
                                                        >
                                                            <i class="far fa-bell"></i>
                                                            <span>Remind invitees</span>
                                                        </button>
                                                    }
                                                </div>
                                            }
                                            <div class="right-items">
                                                <button
                                                    class="btn btn-raised"
                                                    (click)="openOverview(form)"
                                                >
                                                    <span>All results</span>
                                                    <i class="fas fa-arrow-right"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <generic-list-manager
                                        [config]="form._genericConfig"
                                    ></generic-list-manager>
                                </div>
                            </div>
                        }
                    </div>
                }
            }
        </div>
    </div>
} @else {
    <div class="fancy-loader"></div>
}
